const useCalculator = () => {
  const multiply = (args) => [...args].reduce((a, b) => a * b) || 0

  const sum = (args) => [...args].reduce((a, b) => a + b) || 0

  return { multiply, sum }
}

export { useCalculator }
